import { render } from "./segmento.vue?vue&type=template&id=3c5bd7f3&scoped=true"
import script from "./segmento.vue?vue&type=script&lang=js"
export * from "./segmento.vue?vue&type=script&lang=js"

import "./segmento.vue?vue&type=style&index=0&id=3c5bd7f3&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5bd7f3"]])

export default __exports__